export enum AuthCase {
  INVALID_CREDENTIALS,
  MUST_CHANGE_PASSWORD,
  ACCOUNT_LOCKED,
  VALID_CREDENTIALS,
  GENERIC_ERROR
}
